import Vue from "vue";
import VueResource from "vue-resource";
import services from "./services";
import interceptors from "./interceptors";

Vue.use(VueResource);

const http = Vue.http;

//Build de PROD INTERNO
//http.options.root = "http://api.agendamento.prod.polisystem.devel/api/";
//BUIL DE PRODUÇAO EXTERNO
http.options.root = 'https://apiagendamento.polisystem.com.br/api/'

//http.options.root = 'http://192.168.0.5:8080/api/'
//http.options.root = 'http://192.168.80.93:8080/api/'

http.headers.common["Access-Control-Allow-Origin"] = "*";


http.interceptors.push(interceptors);


Object.keys(services).map((service) => {
  services[service] = Vue.resource("", {}, services[service]);
});



const setBearerToken = (token) => {
  http.headers.common["Authorization"] = `Bearer ${token}`;
};

export default services;
export {
  http,
  setBearerToken

};